import { tns } from "tiny-slider/src/tiny-slider";

if ($(".hp-banner").length > 0) {
  let slider = tns({
    container: ".hp-banner__carousel",
    items: 1,
    nav: false,
    loop: true,
    speed: 1200,
    controlsContainer: ".hp-banner__btns",
    autoplay: true,
    autoplayTimeout: 6000,
    autoplayButtonOutput: false,
  });

  slider.events.on("transitionEnd", function (info) {
    if (info.index != 4) {
      $(".hp-banner__info li:first-child").html("0" + info.index);
    } else {
      $(".hp-banner__info li:first-child").html("01");
    }
  });

  $(".hp-banner__btns-prev").on("click", function () {
    const info = slider.getInfo(),
      indexCurrent = info.index;

    if (indexCurrent == 1) {
      $(".hp-banner__info li:first-child").html("03");
    } else {
      $(".hp-banner__info li:first-child").html(
        "0" + (parseInt(indexCurrent) - 1)
      );
    }
  });

  $(".hp-banner__btns-next").on("click", function () {
    const info = slider.getInfo(),
      indexCurrent = info.index;

    if (indexCurrent != 3) {
      $(".hp-banner__info li:first-child").html(
        "0" + (parseInt(indexCurrent) + 1)
      );
    } else {
      $(".hp-banner__info li:first-child").html("01");
    }
  });
}
